import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';

import FilterListIcon from '@mui/icons-material/FilterList';
import ReplayIcon from '@mui/icons-material/Replay';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import ArrowCircleUpOutlinedIcon from '@mui/icons-material/ArrowCircleUpOutlined';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';

import Loading from '../../common/Loading';
import Error from '../../common/Error';
import LoadListFilterOrderList from './LoadListFilterOrderList';
import LoadListFilterProductList from './LoadListFilterProductList';
import LoadListFilterReelList from './LoadListFilterReelList';
import LoadListFilterReelTypeList from './LoadListFilterReelTypeList';
import LoadListFilterProjectList from './LoadListFilterProjectList';
import LoadListFilterStatusList from './LoadListFilterStatusList';
import LoadListFilterSortByList from './LoadListFilterSortByList';
import LoadListFilterNamedLocationList from './LoadListFilterNamedLocationList';
import LoadListFilterCrewList from './LoadListFilterCrewList';
import LoadListFilterTrackerList from './LoadListFilterTrackerList';
import LoadListFilterLengthOperatorList from './LoadListFilterLengthOperatorList';
import LoadListFilterShipDateOperatorList from './LoadListFilterShipDateOperatorList';
import LoadListFilterDaysStationaryOperatorList from './LoadListFilterDaysStationaryOperatorList';

import { useSessionContext } from '../../../contexts/SessionContext';


export default function LoadListFilter(props) {
    //console.debug("RTS Break LoadListFilter");

    const history = useNavigate();

    const {setCurFilter, user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [data, setData] = useState();

    const [orders, setOrders] = useState([]);
    const [products, setProducts] = useState([]);
    const [reelTypes, setReelTypes] = useState([]);
    const [reels, setReels] = useState([]);
    const [projects, setProjects] = useState([]);
    const [status, setStatus] = useState([]);
    const [length, setLength] = useState(0);
    const [lengthOperator, setLengthOperator] = useState(">=");
    const [namedLocations, setNamedLocations] = useState([]);
    const [crews, setCrews] = useState([]);
    const [trackers, setTrackers] = useState([]);
    const [pinned, setPinned] = useState(-1);
    const [locked, setLocked] = useState(-1);
    const [daysStationary, setDaysStationary] = useState(0);
    const [daysStationaryOperator, setDaysStationaryOperator] = useState(">=");
    const [shipDate, setShipDate] = useState();
    const [shipDateOperator, setShipDateOperator] = useState(">=");
    const [sortBy, setSortBy] = useState(0);

    const [showFilter, setShowFilter] = useState(true);
    const [showMore, setShowMore] = useState(true);


    const fetchFilters = useCallback((pFilter) => {
        let apiURL = apiRoot + "/LoadList/GetLoadListFilters";
        axios
        .post(
            apiURL,
            pFilter,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setData(response.data);
            }
            setIsLoading(false);
            setHasError(false);
        })
        .catch(error => {
            setIsLoading(false);
            setHasError(true);
            console.log("RTS Data Error", error);
        });        
    },[apiRoot, userAuthToken.token]);


    useEffect(() => {
        setShowFilter(props.showFilter);
    },[props]);      
    

    useEffect(() => {
        fetchFilters(sessionCustomer.customer);

        setOrders(props.filter.Orders);
        setProducts(props.filter.Products);
        setReelTypes(props.filter.ReelTypes);
        setReels(props.filter.Reels);
        setProjects(props.filter.Projects);
        setStatus(props.filter.Status);
        setLengthOperator(props.filter.LengthOperator);
        setLength(props.filter.Length);
        setNamedLocations(props.filter.NamedLocations);
        setCrews(props.filter.Crews);
        setTrackers(props.filter.Trackers);
        setPinned(props.filter.Pinned);
        setLocked(props.filter.Locked);
        setDaysStationaryOperator(props.filter.DaysStationaryOperator);
        setDaysStationary(props.filter.DaysStationary);
        setShipDateOperator(props.filter.ShipDateOperator);
        setShipDate(props.filter.ShipDate);
        setSortBy(props.filter.SortBy);

    },[fetchFilters]);    


    function setFilter(){
        setCurFilter({key:'LoadListPage', filter:{User:user, 
                        Status:status,
                        Customer:sessionCustomer.customer,
                        Orders:orders, 
                        Projects:projects, 
                        Products:products, 
                        ReelTypes:reelTypes,
                        Reels:reels,
                        LengthOperator:lengthOperator===""?">=":lengthOperator,
                        Length:length===""?0:length,
                        NamedLocations:namedLocations,
                        Crews:crews,
                        Trackers:trackers,
                        Pinned:pinned,
                        Locked:locked,
                        DaysStationaryOperator:daysStationaryOperator===""?">=":daysStationaryOperator,
                        DaysStationary:daysStationary===""?0:daysStationary,
                        ShipDateOperator:shipDateOperator===""?">=":shipDateOperator,
                        ShipDate:shipDate==null?null:shipDate,
                        SortBy:sortBy}
                    });

        props.setFilterFx({User:user, 
            Status:status,
            Customer:sessionCustomer.customer,
            Orders:orders, 
            Projects:projects, 
            Products:products, 
            ReelTypes:reelTypes,
            Reels:reels,
            LengthOperator:lengthOperator,
            Length:length===""?0:length,
            NamedLocations:namedLocations,
            Crews:crews,
            Trackers:trackers,
            Pinned:pinned,
            Locked:locked,
            DaysStationaryOperator:daysStationaryOperator,
            DaysStationary:daysStationary,
            ShipDateOperator:shipDateOperator,
            ShipDate:shipDate,
            SortBy:sortBy}
        );
    }


    function resetFilter(){
        setStatus([1,25,50]);
        setOrders([]);
        setProjects([]);
        setProducts([]);
        setReelTypes([]);
        setReels([]);
        setLengthOperator(">=");
        setLength(0);
        setNamedLocations([]);
        setCrews([]);
        setTrackers([]);
        setPinned(-1);
        setLocked(-1);
        setDaysStationaryOperator(">=");
        setDaysStationary(0);
        setShipDateOperator(">=");
        setShipDate(null);
        setSortBy(0);

        setCurFilter({key:'LoadListPage', filter:{ User:user, 
                        Status:[1,25,50],
                        Customer:sessionCustomer.customer,
                        Orders:[], 
                        Projects:[], 
                        Products:[], 
                        ReelTypes:[],
                        Reels:[],
                        LengthOperator:">=",
                        Length:0,
                        NamedLocations:[],
                        Crews:[],
                        Trackers:[],
                        Pinned:-1,
                        Locked:-1,
                        DaysStationaryOperator:">=",
                        DaysStationary:0,
                        ShipDateOperator:">=",
                        ShipDate:null,
                        SortBy:0}
                    });

        props.setFilterFx({ User:user, 
                        Status:[1,25,50],
                        Customer:sessionCustomer.customer,
                        Orders:[], 
                        Projects:[], 
                        Products:[], 
                        ReelTypes:[],
                        Reels:[],
                        LengthOperator:">=",
                        Length:0,
                        NamedLocations:[],
                        Crews:[],
                        Trackers:[],
                        Pinned:-1,
                        Locked:-1,
                        DaysStationaryOperator:">=",
                        DaysStationary:0,
                        ShipDateOperator:">=",
                        ShipDate:null,
                        SortBy:0
                    });
    }


    function handleScanClick(){
        history("/QRScanPage", {state:{data:''}});
    }    


    function toggleShowFilter()
    {
        props.setShowFilterFx(!showFilter);
    }


    function toggleShowMore()
    {
        setShowMore(!showMore);
    }


    if(hasError){
        return(
            <Error />
        );
    };


    if(isLoading){
        return(
            <Loading />
        );
    };

    
    return (
        <Box sx={{pt:1}}>
            <Box sx={{visibility:showFilter===true?"visible":"hidden", display:showFilter===true?"initial":"none"}}>
                <Grid container id="gridContainer">
                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <LoadListFilterOrderList orders={orders} data={data.orders} setOrdersFx={setOrders} />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <LoadListFilterProductList products={products} data={data.products} setProductsFx={setProducts} />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <LoadListFilterProjectList projects={projects} data={data.projects} setProjectsFx={setProjects} />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <LoadListFilterReelTypeList reelTypes={reelTypes} data={data.reelTypes} setReelTypesFx={setReelTypes} />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <LoadListFilterReelList reels={reels} data={data.reels} setReelsFx={setReels} />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <LoadListFilterStatusList status={status} setStatusFx={setStatus} />
                    </Grid>


                    <Grid item xs={12} sx={{px:1, pt:1}}>
                        <Grid container>
                            <Box onClick={toggleShowMore}>
                                <Button variant="text" size="small">{showMore?'+ More':'- Less'}</Button>
                            </Box>                
                        </Grid>
                    </Grid>                        

                    <Grid item xs={12} sx={{px:1, pt:1, visibility: showMore===true?"hidden":"visible", display:showMore===true?"none":"initial"}}>
                        <Grid container>
                            <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                                <Box sx={{display:'flex'}}>
                                <LoadListFilterLengthOperatorList lengthOperator={lengthOperator} setLengthOperatorFx={setLengthOperator} />
                                <TextField
                                    id="tbMinLength"
                                    margin="none"
                                    fullWidth
                                    label="Length Remaining (ft)"
                                    type="number"
                                    size="small"
                                    value={length}
                                    onChange={(e) => {setLength(e.target.value);}}
                                />
                                </Box>
                            </Grid>

                            <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                                <LoadListFilterNamedLocationList locations={namedLocations}  data={data.namedLocations} setLocationsFx={setNamedLocations} />
                            </Grid>    

                            <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                                <Box sx={{display:'flex'}}>
                                <LoadListFilterDaysStationaryOperatorList daysStationaryOperator={daysStationaryOperator} setDaysStationaryOperatorFx={setDaysStationaryOperator} />
                                <TextField
                                    id="tbDaysStationary"
                                    margin="none"
                                    fullWidth
                                    label="Days Stationary"
                                    type="number"
                                    size="small"
                                    value={daysStationary}
                                    onChange={(e) => {setDaysStationary(e.target.value);}}
                                />
                                </Box>
                            </Grid> 
                            <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                                <LoadListFilterCrewList crews={crews}  data={data.crews} setCrewsFx={setCrews} />
                            </Grid>                                                           
                            <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Box sx={{display:'flex'}}>
                                    <LoadListFilterShipDateOperatorList shipDateOperator={shipDateOperator} setShipDateOperatorFx={setShipDateOperator} />
                                    <DatePicker
                                        id="tbShipDate"
                                        label="Ship Date"
                                        inputFormat="MM/dd/yyyy"
                                        value={shipDate}
                                        onChange={setShipDate}
                                        slotProps={{ field: { clearable: true }, textField:{size:'small'} }}
                                    />   
                                </Box>
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                                <LoadListFilterTrackerList trackers={trackers}  data={data.trackers} setTrackersFx={setTrackers} />
                            </Grid>                                                           
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:3}} >
                                <LoadListFilterSortByList sortBy={sortBy} setSortByFx={setSortBy} />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sx={{px:1, pt:1}}>
                        <Grid container>
                            <Grid item xs={12} sm={6} lg={6} sx={{textAlign:{xs:'center', sm:'left'}}}>
                                <Button type="button" variant="contained" onClick={setFilter} sx={{mt:1}} >
                                    <FilterListIcon />
                                    <Typography sx={{ml:1}}>Filter</Typography>
                                </Button>
                                <Button type="button" variant="contained" onClick={resetFilter} sx={{mt:1, ml:2}} >
                                    <ReplayIcon />
                                    <Typography sx={{ml:1}}>Reset</Typography>
                                </Button>                                
                            </Grid>
                            <Grid item xs={12} sm={6} lg={6} sx={{textAlign:{xs:'center', sm:'right'}}}>
                                <Button type="button" variant="contained" onClick={handleScanClick} sx={{mt:1}} >
                                    <QrCodeScannerIcon />
                                    <Typography sx={{ml:1}}>Scan</Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>                        
                </Grid>
                <Box onClick={toggleShowFilter}>
                    <Button variant="text" startIcon={<ArrowCircleUpOutlinedIcon />} size="small">Hide Filters</Button>
                </Box>                
            </Box>
            <Box sx={{visibility: showFilter===true?"hidden":"visible", display:showFilter===true?"none":"initial"}}>
                <Box onClick={toggleShowFilter}>
                    <Button variant="text" startIcon={<ArrowCircleDownIcon />} size="small">Show Filters</Button>
                </Box>
            </Box>                     
        </Box>
    );
}
